import { render, staticRenderFns } from "./msg-row.vue?vue&type=template&id=6adba00b&scoped=true"
import script from "./msg-row.vue?vue&type=script&lang=js"
export * from "./msg-row.vue?vue&type=script&lang=js"
import style0 from "./msg-row.vue?vue&type=style&index=0&id=6adba00b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adba00b",
  null
  
)

export default component.exports